/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { LoadingService } from './core/services/loading.service';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit{
  title = 'Bag Radar Portal';
  loadingSpinner$ = new BehaviorSubject<boolean>(true);
  private readonly cdr = inject(ChangeDetectorRef); // Inject ChangeDetectorRef

  constructor(private readonly loader: LoadingService,   private readonly router:Router ) {
    this.loader.loadingSpinner.subscribe({next: (response:boolean) => {
      this.loadingSpinner$.next(response)
    }})
  }

  ngOnInit(): void {
    this.router.events.forEach((event: any) => {
      // After Navigation
      if (event instanceof NavigationEnd) {
        // Mark for change detection
        this.cdr.detectChanges();
      }
    });
  }
}
